// Debugging confirmation
console.log('✅ main.js loaded successfully!');

//// don't think this is needed anymore, but keeping it here for reference
import './js/loader-styles-core.js';
import './js/loader-styles-components.js';
import './js/loader-styles-pages.js';
////import "./js/loader-styles-behind.js";

/**
 * Preload the routes at the start of the application
 * This ensures routes are ready when the app is initialized
 */
async function preloadRoutes() {
  try {
    console.log('📥 Preloading routes...');
    const routes = await import(
      /* webpackChunkName: "routes" */ './data/routes-and-translated-links.json'
    );
    console.log('✅ Routes preloaded successfully!');
    return routes.default;
  } catch (error) {
    console.error('❌ Error preloading routes:', error);
    return {};
  }
}

export async function initializeApp() {
  console.log('🚀 App initializing...');

  try {
    // ✅ Preload routes at the very start
    const preloadedRoutes = await preloadRoutes();

    // Preload all essential modules in parallel
    const [
      { loadPersistentState, appState, setAppStateValueByKey },
      { loadPageFromURL },
      { setupNavigationForApp },
      { loadRoutes, setRouteMappings },
      { loadTextTranslations },
    ] = await Promise.all([
      import('./js/state.js'),
      import('./js/router.js'),
      import('./js/router-navigator.js'),
      import('./js/router-routes-manager.js'),
      import('./js/translator.js'),
    ]);

    function isNodeEnvironment() {
      return typeof process !== 'undefined' && process.versions && process.versions.node;
    }

    function getBaseURL() {
      if (isNodeEnvironment()) {
        return 'http://localhost:3000'; // Replace with your Node.js server URL
      } else {
        //let url = `${location.origin}${location.pathname}`.replace(/\/$/, '');
        let url = `${location.origin}`.replace(/\/$/, '');

        //  alert("URL: " + url);
        return url; // ✅ Add this line
      }
    }

    const baseURL = getBaseURL();
    //appState.BASE_URL = getBaseURL(); // Set the base URL for the application
    setAppStateValueByKey('BASE_URL', baseURL);

    // ✅ Set the preloaded routes directly to avoid re-fetching
    if (Object.keys(preloadedRoutes).length > 0) {
      console.log('🔧 Setting preloaded routes...');

      //forced Webpack to bundle that JSON into its own chunk and to parse it once at app startup.
      setRouteMappings(preloadedRoutes); // Custom function to set preloaded routes
    }

    // Load stored state
    loadPersistentState();
    console.log('✅ State loaded:', appState);

    //to delete, for testing only

    // setAppStateValueByKey("MyUserIsAuthenticated", true);
    //// setAppStateValueByKey("MyBuyingEntityType", "Personal");
    // setAppStateValueByKey("MyBuyingEntityType", "Business");
    //// setAppStateValueByKey("MyBuyingEntityType", "Guest");
    // setAppStateValueByKey("UserHasAtLeastOneBuyingCompanyAccess", true);

    //setAppStateValueByKey("MyUserIsAuthenticated", true);
    //setAppStateValueByKey("MyLoggedInUserID", "3332f1b3-914c-4875-bdc8-0d8adaee9f47");
    //setAppStateValueByKey("MyBuyingEntityID", "3332f1b3-914c-4875-bdc8-0d8adaee9f47");
    //setAppStateValueByKey("MyBuyingEntityType", "Personal");
    //setAppStateValueByKey("MyBuyingEntityCompanyName", "CompanyName");
    //setAppStateValueByKey("UserHasAtLeastOneBuyingCompanyAccess", true);

    await setupNavigationForApp(); // Set up the navigation

    // Explicitly call loadRoutes if preloading failed
    if (!Object.keys(preloadedRoutes).length) {
      await loadRoutes();
      console.log('✅ Routes loaded during app initialization.');
    } else {
      console.log('✅ Routes loaded from preloaded data.');
    }

    console.log('✅ Loading Texts Translations at initializeApp:');
    await loadTextTranslations(appState?.SiteLanguageCookie || 'en');
    console.log('✅ Texts Translations loaded.');

    // Load the correct page based on URL
    await loadPageFromURL();

    console.log('🎉 App fully initialized!');
  } catch (error) {
    console.error('❌ Error during app initialization:', error);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', async () => {
    console.log('✅ DOM loaded normally main.js.');
    await initializeApp();

    await preloadAllMasters();
  });
} else {
  console.log('⚠️ DOM was already loaded, running script manually main.js.');
  await initializeApp();

  await preloadAllMasters();
}

async function preloadAllMasters() {
  const [{ prebuildMasterIfNotBuilt }] = await Promise.all([
    import(
      /* webpackChunkName: "utils-prebuild-master-pages" */ './js/utils-prebuild-master-pages.js'
    ),
  ]);

  ['master-layout-shop', 'master-layout-blog', 'master-layout-light'].forEach(async master => {
    await prebuildMasterIfNotBuilt(master);
  });
}

//["master-layout-shop", "master-layout-blog", "master-layout-light", "master-layout-slim", "master-layout-dashboard-user", "master-layout-dashboard-seller", "master-layout-dashboard-terms-and-conditions"]
